function DownloadableDirective() {
  function supportIE(elem, trackingCode) {
    let fileData = [trackingCode];
    blobObject = new Blob(fileData);
    elem.on('click', () => {
      window.navigator.msSaveOrOpenBlob(blobObject, 'tracking.html');
    });
  }

  return {
    restrict: 'A',
    scope: {
        trackingCode: '@'
    },
    link: function(scope, elem, attrs) {
      attrs.$observe('trackingCode', (trackingCode) => { 
          // If we are on Chrome / Firefox / Safari
        if (!window.navigator.msSaveOrOpenBlob) { 
          let url = "data:text/html;charset=utf-8," + encodeURIComponent(trackingCode);
          elem.attr('download', 'tracking.html');
          elem.attr('href', url)
        } else {
          supportIE(elem, trackingCode);
        }
      });
    }
  };
}

export default DownloadableDirective;



// WEBPACK FOOTER //
// ./client/app/pages/marketing/directive/downloadable.directive.js